<template>
    <div class="flex justify-center items-center md:mt-[10vh] flex-col text-center">
        <h1 class="font-bold text-4xl mb-20">
            Log in
        </h1>

        <p v-if="errorNotice" class="bg-red-600 text-white max-w-[800px] rounded my-20 p-10" v-html="errorNotice"/>

        <p class="max-w-[800px] my-20">
            To continue, please sign in to your account on DigitalNomadCafes.com. We currently support signing in using
            Twitter or by email. If you
            would like to use a different method to log in, please send feedback my way by shooting me a Tweet at
            @MaxKorlaar!
        </p>

        <div class="md:grid items-center max-w-[800px]">
            <div class="md:mr-20 md:ml-auto">
                <a
                    class="bg-indigo-400 px-15 py-10 text-white rounded transition-colors hover:bg-pink-500 focus:bg-pink-500"
                    :href="`/auth/twitter/redirect?redirectTo=${$route.query?.redirectTo ?? '/'}`">
                    Log in using Twitter
                </a>
            </div>

            <div class="my-10 md:my-0">
                or
            </div>

            <div class="md:ml-20 text-left">
                <form
                    v-if="!viewEmail"
                    @submit.prevent="submitEmailForm"
                >
                    <FormInput
                        id="email"
                        v-model="email"
                        :disabled="loggingIn"
                        :errors="errors.email"
                        class="max-w-[340px]"
                        help-text="Please use a valid email address. You will be sent an email to log in or register yourself with."
                        label="Email address"
                        required
                        type="email"
                        autocomplete="email"
                    />
                    <button
                        :class="{ 'cursor-wait': loggingIn }"
                        :disabled="loggingIn"
                        class="bg-indigo-400 px-15 py-10 text-white rounded transition-colors hover:bg-pink-500 focus:bg-pink-500"
                        type="submit">
                        Log in or register
                    </button>
                    <p
                        v-if="Object.keys(errors).length > 0 && !errors.email"
                        class="text-red-500">
                        There is an error in your email address. Please correct this and try again
                    </p>
                </form>
                <div v-else>
                    <h2 class="font-bold text-xl mb-10 text-center">Check your email!</h2>
                    <p class="text-center">
                        Please check your email for further instructions on logging in or creating your account on
                        DigitalNomadCafes.com!
                        We're honoured to have you with us 😁
                    </p>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
import FormInput from "../../components/FormInput";
import {useMeta} from "vue-meta";
import axios from "axios";

export default {
    name: "Login",
    components: {FormInput},
    data() {
        return {
            email: '',
            loggingIn: false,
            errors: {},
            viewEmail: false,
            errorNotice: null
        };
    },
    setup() {
        useMeta({
            title: 'Log in',
        });
    },
    beforeMount() {
        if (this.$route.query?.error === 'url-expired') {
            this.errorNotice = "Unfortunately, the link you have tried to use has expired.<br>Please request a new link using the login form below.";
        } else if (this.$route.query?.error === 'twitter-redirect-error') {
            this.errorNotice = "We're having problems communicating with Twitter's API right now.<br>Please try again later or log in using the email address associated with your account.";
        }
    },
    methods: {
        submitEmailForm() {
            this.loggingIn = true;
            axios.post(`/auth/email`, {
                email: this.email,
                redirectTo: decodeURIComponent(this.$route.query?.redirectTo)
            }).then(() => {
                this.viewEmail = true;
                this.errors = {};
            }).catch(error => {
                this.errors = error.response?.data?.errors ?? {};

                if (error.response?.status === 429) {
                    this.errors = {
                        email: ['Oops! You\'re trying this too fast. Please wait a minute and try again.']
                    };
                }

                console.error(error);
                // alert("Sorry, something went wrong:\n" + error);
            }).finally(() => {
                this.loggingIn = false;
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.items-center {
    grid-template-columns: 1fr auto 1fr;
}
</style>
